import { render, staticRenderFns } from "./LocalizarProduto.vue?vue&type=template&id=55c4c6ea&scoped=true"
import script from "./LocalizarProduto.vue?vue&type=script&lang=js"
export * from "./LocalizarProduto.vue?vue&type=script&lang=js"
import style0 from "./LocalizarProduto.vue?vue&type=style&index=0&id=55c4c6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4c6ea",
  null
  
)

export default component.exports